export class UnknownBusinessError extends Error {
    public readonly name = 'UnknownBusinessError';
    public constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, UnknownBusinessError.prototype);
    }
}
